export function PageSubtitle({ children, ...props }) {
  return (
    <h2 className="mb-2 text-xl leading-none text-gray-100" {...props}>
      {children}
    </h2>
  );
}
